export function downloadCSV(filename, rows){
  if(!rows || !rows.length) return;

  const headers = Object.keys(rows[0]);
  const escape = (v) => {
    const s = String(v===undefined||v===null ? "" : v);
    if(s.includes('"') || s.includes(",") || s.includes("\n")){
      return `"${s.replace(/"/g,'""')}"`;
    }
    return s;
  };

  const lines = [
    headers.join(","),
    ...rows.map(r => headers.map(h => escape(r[h])).join(","))
  ];

  const blob = new Blob([lines.join("\n")], {type:"text/csv;charset=utf-8"});
  const url = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();

  URL.revokeObjectURL(url);
}
